/* eslint-disable eag/match-named-export */
import {createContext, TestIdProps, Nullish} from 'shared/web';

type ChoiceContext = TestIdProps & {
  hasOptionCheckbox?: boolean;
  isInvalid?: boolean; // tw-only extension
  /** Announced on the input as `aria-required`, whether or not a visible label says it. */
  isRequired?: boolean;
  'data-name'?: string;
  imageCache: Map<string, string | Nullish>;
  setImageCache: (optionId: string, imageUrl: string | Nullish) => void;
};

export const [ChoiceContextProvider, useChoice] = createContext<ChoiceContext>({
  strict: false,
  name: 'ChoiceContext',
});
